const volumeLabels = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  HIGH: 'High',
  VERY_HIGH: 'Very High',
  NOT_APPLICABLE: 'N/A',
};

export default volumeLabels;
